<template>
    <div>
        <EmailSetting typeSetting="sender"></EmailSetting>
    </div>
</template>

<script>
import EmailSetting from '../email-setting/main.vue';
export default {
    name: 'EmailReply',
    components: {
        EmailSetting
    }
};
</script>

<style lang="scss" scoped></style>
